import { sanitizeHtml, SERVICE_DESCRIPTION_ALLOWED_TAGS } from "./sanitizeHtml";

// A service description is plain text when it comes from the add-service form
// or an import, and HTML when it comes from the Services page's rich-text
// editor. Only tags that editor (or a pasted snippet) writes count as markup,
// so plain text such as "Kids < 12" is never parsed.
const RICH_TEXT_TAG_PATTERN =
  /<\/?(?:p|br|hr|strong|b|em|i|u|s|mark|blockquote|code|pre|ul|ol|li|span|a|div|img|h[1-6])(?:\s[^<>]*)?\/?>/i;

export const isRichTextDescription = (value) =>
  typeof value === "string" && RICH_TEXT_TAG_PATTERN.test(value);

const hasWords = (html) => {
  try {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    return Boolean(parsed.body?.textContent?.trim());
  } catch {
    return false;
  }
};

// What a booking page shows for a description: null for none, { text } for
// plain text, shown exactly as before, or { html } for sanitized markup. The
// editor saves "<p></p>" once it is cleared, which has no words, so it is none.
export const resolveServiceDescription = (value) => {
  if (typeof value !== "string" || !value.trim()) return null;
  if (!isRichTextDescription(value)) return { text: value };

  const html = sanitizeHtml(value, { allowedTags: SERVICE_DESCRIPTION_ALLOWED_TAGS });
  return hasWords(html) ? { html } : null;
};
